export const config = {
  GOOGLE_MAPS_API_KEY: 'AIzaSyAf1tng6_bMkXNyPAsHBAK4GvD1zR6xoKE',
  GOOGLE_SHEETS_JSON: 'https://script.google.com/macros/s/AKfycby2vvJ5RGrxO2wdnrg6ZPywxDra6wGG1zO3M_TGCw5yIK9MYS8x3D8vqB1BF3mrynrMEg/exec' // Will be updated after Google Sheets setup
};




// WEBPACK FOOTER //
// ./src/pages/findGrumple/utils/config.js